function Contact() {
  return (
    <section className="section contact-section">
      <div className="container">
        <div className="contact-content">
          <div className="contact-links">
            <a href="https://github.com/makumasaka" target="_blank" rel="noopener noreferrer" className="contact-link">
              Github
            </a>
            <a href="https://www.linkedin.com/in/makoto-kumasaka-937b36ab/" target="_blank" rel="noopener noreferrer" className="contact-link">
              LinkedIn
            </a>
            <a href="mailto:thingsmadebymako@gmail.com" className="contact-link">
              Email
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Contact

